var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 1.81818C2.17575 1.81818 1.77778 2.2252 1.77778 2.72727V17.2727C1.77778 17.7748 2.17575 18.1818 2.66667 18.1818H13.3333C13.8243 18.1818 14.2222 17.7748 14.2222 17.2727V7.19988C14.2222 6.9345 14.1088 6.68236 13.9118 6.50965L8.80973 2.03704C8.64862 1.89581 8.44343 1.81818 8.23125 1.81818H2.66667ZM0 2.72727C0 1.22104 1.19391 0 2.66667 0H8.23125C8.86781 0 9.48337 0.232888 9.96669 0.656573L15.0688 5.12918C15.6598 5.64732 16 6.40372 16 7.19988V17.2727C16 18.779 14.8061 20 13.3333 20H2.66667C1.19391 20 0 18.779 0 17.2727V2.72727Z",
    fill: "#46A348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.54547V1.36365H9.77778V4.54547C9.77778 5.04754 10.1757 5.45456 10.6667 5.45456H14.6667V7.27274H10.6667C9.19391 7.27274 8 6.0517 8 4.54547Z",
    fill: "#46A348"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5556 17.2727H4.44446V15.4545H11.5556V17.2727Z",
    fill: "#46A348"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88886 13.6364V8.18181H7.11108V13.6364H8.88886Z",
    fill: "#46A348"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3715 14.2792C7.71863 14.6342 8.28145 14.6342 8.62858 14.2792L11.2952 11.5519L10.0382 10.2663L8.00004 12.3507L5.96191 10.2663L4.70483 11.5519L7.3715 14.2792Z",
    fill: "#46A348"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.4e7a31ae58ad728b09b098f5be340c04.svg";
export { ForwardRef as ReactComponent };